import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';

import { useToast } from '@/components/ui/use-toast';
import { TEvent } from '../types';
import { label } from '@/utils/label';
import { LabelGroup } from '@/features/label/types';

const QUERY_KEY = 'event';

export const deleteEvent = ({ eventId }: { eventId: number }) => {
  return axios.delete(`/event/${eventId}`);
};

type DeleteEventOptions = {
  eventId: number;
  organizerId: number;
  config?: MutationConfig<typeof deleteEvent>;
};

export const useDeleteEvent = ({ config, eventId,organizerId }: DeleteEventOptions) => {
  const { toast } = useToast();

  return useMutation({
    onMutate: async (deletedUser) => {
      await queryClient.cancelQueries([QUERY_KEY, deletedUser.eventId]);

      const previousUsers = queryClient.getQueryData<TEvent[]>(['events', organizerId]);

      queryClient.setQueryData(
        [QUERY_KEY],
        previousUsers?.filter((user) => user?.eventId !== deletedUser.eventId)
      );

      return { previousUsers };
    },
    onError: (_, __, context: any) => {
      if (context?.previousUsers) {
        queryClient.setQueryData(['events', organizerId], context.previousUsers);
      }
      toast({
        variant: 'destructive',
        title: label('something_went_wrong', LabelGroup.GLOBAL),
      });
    },
    onSuccess: async () => {

      await queryClient.cancelQueries([QUERY_KEY, eventId])
      queryClient.removeQueries([QUERY_KEY, eventId])

      queryClient.invalidateQueries(['events', organizerId]);

      toast({
        variant: 'success',
        title: label('event_deleted_successfully', LabelGroup.ORGANIZER_EVENT_LIST),
      });
    },
    ...config,
    mutationFn: ({ eventId }) => deleteEvent({ eventId }),
  });
};
